import AppLayoutComponent from './AppLayoutComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getClientFavicon } from '../actions/ui/init/initSelectors';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  favicon: getClientFavicon(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({}, dispatch);

// Create higher-order component which feeds in specified props.
const AppLayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppLayoutComponent);

export default AppLayoutContainer;



// WEBPACK FOOTER //
// ./src/components/AppLayoutContainer.js